<template>
    <li>
        <span  v-bind:class="{'level1 ': true,
                              'button': true,
                              'switch':true,
                              'noline_open': treeData.children && treeData.isExpand,
                              'noline_close': treeData.children && !treeData.isExpand,
                              'center_docu':!treeData.children && !treeData.isLastNode,
                              'bottom_docu':!treeData.children && treeData.isLastNode}"
              @click="changeExpand(treeData)">
        </span>
        <a class="level1"
           v-bind:class="{'level1 ': true,'curSelectedNode': treeData.isSelected}"
           @click="selectNode(treeData)">
            <!-- <span v-bind:class="{'ico_open': treeData.children,
                                    'ico_docu':treeData.children == null || treeData.children.length == 0,
                                    'button':true}">
            </span> -->
            <span class="org-icon">
                <zx-icon :type="treeData.level < 3 ? 'icon-jigou' : 'icon-organize'"></zx-icon>
            </span>
            <span class="node_name" id="treeDemo_9_span">{{treeData.name}}</span>
        </a>

        <ul v-if="treeData.children && treeData.isExpand"
            v-bind:class="{'line': treeData.isLastNode == false,
                             'level1':true}"
            style="display:block">
            <z-org-chooser-item v-for="item in treeData.children" :treeData="item" :key="item.id" @selectNode="onSelectNode"></z-org-chooser-item>
        </ul>
    </li>

</template>

<script>
    export default {
        name: "ZOrgChooserItem",
        components: {
        },
        data: function () {
            return {}
        },
        props: ['treeData'],
        methods: {
            changeExpand(node) {
                node.isExpand = !node.isExpand;
            },
            selectNode(node) {
                this.$emit('selectNode', node);
            },
            onSelectNode(node) {
                this.$emit('selectNode', node);
            }
        },
        created() {

        }
    }
</script>
